/**
 * @Author: Daniel Rhees <Daniel>
 * @Date:   2017-04-06T16:13:17-07:00
 * @Email:  daniel@reflexmedia.com
 * @Last modified by:   Daniel
 * @Last modified time: 2017-04-17T15:00:24-07:00
 */




 import React, { Component } from 'react';
 import { css, StyleSheet } from 'aphrodite/no-important';
 import { spacing, borders, type, textColor, leading } from '../../../style';
 import Avatar from '../../common/Avatar';
 import { Link } from 'react-router';
 import { tsSince } from '../../../common';


 const style = StyleSheet.create({
   container: {
     display: 'flex',
     borderBottom: borders.DEFAULT,
     ...spacing.PADDING_SM,
   },

   img: {
    ...spacing.MARGIN_RIGHT_SM
   },

   content: {

   },

   activityLine: {
     ...type.DARK,
     ...leading.LOOSE
   },

   metaLine: {
     ...textColor.NORMAL
   },

   username: {
     ...type.BOLD,
     fontStyle: 'normal'
   },

   time: {
     ...leading.LOOSE,
     ...textColor.NORMAL,
     fontSize: 13
   }
 })


 class ActivityItem extends Component {

   render() {

    let {
      acct,
      profile,
      feedType,
      linkTo,
      activityDt
     } = this.props

     const msgTypes = {
       fav: 'favorited you',
       msg: 'sent you a message'
     }

     let activityMsg = msgTypes[feedType]



     return (
       <Link to={linkTo + acct.username} className={css(style.container)}>
        {/* <pre><code>{JSON.stringify(this.props, null, 3)}</code></pre> */}
         <div className={css(style.img)}>
           <div style={{height: 62, width: 62}}>
             <Avatar src={profile.avatar.data.urls.thumbs}/>
           </div>
         </div>
         <div className={css(style.content)}>
           <div className={css(style.activityLine)}><em className={css(style.username)}>{acct.username}</em> {activityMsg}</div>
           <div className={css(style.metaLine)}>{profile.age} · {profile.city}, {profile.region}, {profile.country}</div>

           <div className={css(style.time)}>{tsSince(activityDt)}</div>
         </div>
       </Link>
     );
   }
 }

 export default ActivityItem;



// WEBPACK FOOTER //
// ./src/components/pages/Dashboard/ActivityItem.jsx